import { render, staticRenderFns } from "./ComfirmGenerateCommissionModal.vue?vue&type=template&id=a55feb64"
import script from "./ComfirmGenerateCommissionModal.vue?vue&type=script&lang=js"
export * from "./ComfirmGenerateCommissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports